import { render, staticRenderFns } from "./ContactInfoView.vue?vue&type=template&id=ebf2dd6c&scoped=true"
import script from "./ContactInfoView.vue?vue&type=script&lang=js"
export * from "./ContactInfoView.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoView.vue?vue&type=style&index=0&id=ebf2dd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf2dd6c",
  null
  
)

export default component.exports